export default __webpack_public_path__ + "e9d53ec840bac912d4ebb628cd9e8ea6.png";